import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { MisdeliveryFormData } from "../models";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create Misdelivery entry and return same object
 */

export const CreateMisdeliveryEntry = async (params: MisdeliveryFormData) => {
    try { 
        const { data } = await axios.post(getUrl(ApiType.MISDELIVERY_CREATE), params);
        return data;
    } catch (error: any) {
        return throwApiError(error, ErrorMessages.createMisdeliveryEntry, { badRequestOrder: "errorsFirst" });
    }
};
